<template>
<span>
     <p><span style="font-size:10pt">Nach DIN EN 62305-3 oder IEC 62305-3</span></p>

      <ul>
        <li>
          <p><span style="font-size:10pt">Sch&auml;tzung der Materialkosten (+/-20%) von Blitzschutz und/oder Erdungsma&szlig;nahmen</span></p>
        </li>
        <li>
          <p><span style="font-size:10pt">Angabe der Planungskosten durch DEHN</span></p>
        </li>
        <li>
          <p><span style="font-size:10pt">Angabe der geplanten Ma&szlig;nahmen f&uuml;r den Blitzschutz</span></p>
        </li>
      </ul>

      <p><span style="font-size:9pt"><em>Optional: Es kann ein Blitzschutz- und/oder Erdungskonzept auf Basis der Budgetplanung ausgearbeitet werden.</em></span></p>

      <p><span style="font-size:9pt"><em>Hinweis: Die Kosten der Budgetplanung k&ouml;nnen bei der Beauftragung eines Blitzschutz-/Erdungskonzeptes gutgeschrieben werden</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipBudgetplanung"
}
</script>

<style scoped>

</style>
